import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontFooter from './footer'
import FrontProgress from './progress';
import FrontTarifsAlone from './tarifsAlone';
import FrontOptionsAlone from './optionsAlone'
import FrontEcheancier from './echeancier';
import error_warning from '../img/error-warning-line-yellow.png'
import FieldSelect from './fields/fieldSelect';

export default class FrontError extends React.Component {
    
    constructor(props) {
        super(props);
    }

    onSubmit() {}


    render() {
        const devis = this.props.devis
        const params = devis.params
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage,
            focusError: ()=>{}
        }
        const precisions =  
            ( params.error && params.error.includes( 'Veuillez nous contacter pour plus de précisions concernant cette personne à assurer' ) )
            ||( this.props.devis.validated == -2 )
        return <>
        <FrontProgress onSubmit={this.onSubmit.bind(this)} comparateursCompleted={this.props.devis.params.comparateursCompleted} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container">
            <div className="contentbox front_form">
                <div className="contentvbox">

                {precisions 
                ?<>
                    <h1 className="top_title" >Votre devis est en attente de validation</h1>
                    {params.docs_a_fournir 
                        ? <><h3 className="main_line">
                            Afin de pouvoir valider votre devis nous avons besoin que vous nous fassiez parvenir les documents suivants&nbsp;:
                        </h3>
                            <ul>
                            {params.docs_a_fournir.map(
                                row => <li key={row} dangerouslySetInnerHTML={{__html: row.replaceAll('&nbsp;','')}} ></li>
                            )}
                            </ul>
                        </> : <h3 className="main_line">
                            Votre profil nécessite un traitement manuel de la part de nos équipes.
                        </h3>
                    }
                    


                    <h2>
                        Merci de nous contacter, du lundi au vendredi, au&nbsp;:
                    </h2>
                        <p className="telephone_left">
                            <a href="tel:0974772861">09 74 77 28 61</a>
                        </p>
                </>:<>


                <br/>
                    <p className="error">
                    <img src={error_warning}/> {params.error}
                    </p>
                </>}


    {/*            <p>
                Si certaines informations sont erronées, n'hésitez pas à les modifier en cliquant sur le bouton ci-dessous&nbsp;:
            </p> */}
                <p>
                    <a className="button button_subscribe" onClick={()=>this.props.setPage('vehicule')}>
                    Modifier vos informations&nbsp;<span>▸</span> 
                    </a>
                </p>
                {this.props.embeded
                ? <>
                    <FieldSelect field="frais" container={container} options={devis.getOptionsFrais(this.props.api.isAdmin())} />
                </> : ''}
                </div>

                {precisions
                ?<>
                    <div className="contentvbox">

                        <h1>Nos tarifs</h1>
                        <FrontTarifsAlone container={container}/>
                        <h1>Options disponibles</h1>
                        <FrontOptionsAlone container={container}/>

                    </div>
                </>:''
                }
            </div>

            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={this.props.api} devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>
            <div className="contentbox_margin"/>

            </div>
        </>
    }
}